module.exports = __webpack_public_path__ + "static/media/logo2.38637623.svg";